<script>
export default {
  name: "SuccessBox",
  props: {
    title: {
      type: String,
    },
    description: {
      type: String,
    },
    image: {
      type: String,
    },
  }
}
</script>

<template>
    <article>
        <img
            :src="image"
            :alt="title"
            class="img-fluid mb-2"
            loading="lazy"
            decoding="async"
        />

        <h3 class="beta fw-semibold">{{ title }}</h3>
        <p>{{ description }}</p>
    </article>
</template>

<style lang="scss" scoped>
img {
    border-radius: 1rem;
}
h3 {
    margin-bottom: 0.6rem;
}
</style>
